// src/components/layout/Footer.js
import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';
import {
  Shield,
  Mail,
  Info,
  Heart,
  ExternalLink,
  Zap,
} from 'lucide-react';
import logo from '../../assets/images/zone-icon.png';
import styles from './Footer.module.css';

// ─────────────────────────────────────────────────────────────
// DONNÉES
// ─────────────────────────────────────────────────────────────
const FOOTER_LINKS = [
  { to: '/#about',   Icon: Info,    label: 'À Propos'        },
  { to: '/#privacy', Icon: Shield,  label: 'Confidentialité' },
  { to: '/#contact', Icon: Mail,    label: 'Contact'         },
];

const APP_LINKS = [
  { to: '/home',       label: 'Accueil'       },
  { to: '/management', label: 'Pilotage'      },
  { to: '/support',    label: 'Aide'          },
];

// ─────────────────────────────────────────────────────────────
// COMPOSANT
// ─────────────────────────────────────────────────────────────
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      {/* Ligne décorative du haut */}
      <div className={styles.topBar} aria-hidden="true" />

      <div className={styles.container}>

        {/* ── Colonne Brand ── */}
        <div className={styles.brand}>
          <div className={styles.brandLogo}>
            <img src={logo} alt="CVtoSkill" className={styles.logoImg} />
            <span className={styles.brandName}>CVtoSkill</span>
          </div>
          <p className={styles.brandTagline}>
            La plateforme RH intelligente pour valoriser vos talents.
          </p>
          <div className={styles.brandBadge}>
            <Zap size={12} strokeWidth={2.5} />
            Propulsé par l'IA
          </div>
        </div>

        {/* ── Colonne Navigation App ── */}
        <div className={styles.col}>
          <p className={styles.colTitle}>Application</p>
          <nav className={styles.colLinks}>
            {APP_LINKS.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `${styles.colLink} ${isActive ? styles.colLinkActive : ''}`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* ── Colonne Légal & Contact ── */}
        <div className={styles.col}>
          <p className={styles.colTitle}>Informations</p>
          <nav className={styles.colLinks}>
            {FOOTER_LINKS.map(({ to, Icon, label }) => (
              <Link key={to} to={to} className={styles.colLink}>
                <Icon size={13} strokeWidth={2} />
                {label}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      {/* ── Barre du bas ── */}
      <div className={styles.bottomBar}>
        <p className={styles.copyright}>
          © {year} CVtoSkill — Tous droits réservés
        </p>
        <p className={styles.madeWith}>
          Fait avec <Heart size={12} strokeWidth={2.5} className={styles.heart} /> en France
        </p>
      </div>
    </footer>
  );
};

export default Footer;